import { MobileDrawer } from 'components/drawers/MobileDrawer';
import { SettingsDialog } from './SettingsDrawer';

export const AllDrawers = () => (
  <>
    <SettingsDialog />
    <MobileDrawer />
  </>
);
